export const CssdRouteDef = [ 
    {
        path: ':id/:resource',
        component: 'IndentIssueComponent',
        data: {
            selector: 'app-indent-issue'
        }
    },
    {
        path: ':id/stock_update_batch/updateBatch',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'stock_update_batch',
            action: 'MODIFY',
        }
    },
     {
        path: ':id/stock_update_batch/updateExpiry',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'stock_update_expiry',
            action: 'MODIFY',
        }
    },
     {
        path: ':id/stock_update_batch/updateMRP',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'stock_update_mrp',
            action: 'MODIFY',
        }
    },
    {
        path: ':id/stock_update_qty/updateStock',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'stock_update_qty',
            action: 'MODIFY',
        }
    }
]       